// Shown when ``validateConfig()`` detects that a production build is missing
// required ``VITE_*`` values. Prevents the app from silently booting with
// localhost defaults (AUDIT.md H6).

export default function ConfigErrorScreen({ missing = [] }) {
  return (
    <div
      role="alert"
      className="min-h-screen flex flex-col items-center justify-center p-8 text-center bg-bg text-text"
    >
      <h1 className="text-3xl font-bold mb-3">Configuration error</h1>
      <p className="max-w-md text-secondText mb-6">
        The Plumescript web app was built without the required runtime
        configuration. The operator needs to rebuild the Docker image with
        these environment variables set.
      </p>
      <ul className="app-surface px-5 py-4 text-sm font-mono text-left">
        {missing.map((name) => (
          <li key={name}>missing: <strong>{name}</strong></li>
        ))}
      </ul>
    </div>
  );
}
